import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import sanitizeRegex from 'notebook/tables/excess/util/sanitizeRegex';

export default {
  name: 'SEARCH',
  category: FunctionCategory.LOOKUP,
  shortDescription: 'Returns the position at which a string is first found within text, ignoring case.',
  description: 'Returns the position at which a string is first found within text, ignoring case.',
  params: [
    {
      name: 'search_for',
      type: ArgType.text,
      description: 'The string to look for within text_to_search.',
    },
    {
      name: 'text_to_search',
      type: ArgType.text,
      description: 'The text to search for the first occurrence of search_for.',
    },
    {
      name: 'starting_at',
      optional: true,
      type: ArgType.positiveInteger, // As a known quirk, if invalid, we raise #NUM while Excel raises #VALUE
      description: 'The character within text_to_search at which to start the search. Default is 1.',
    },
  ],
  eval: (searchFor: string, textToSearch: string, startingAt?: number): number => {
    if (textToSearch.length === 0) {
      throw new util.ValueError('text_to_search value should be non-empty.');
    }
    if (!startingAt) {
      startingAt = 1;
    }
    if (startingAt < 1) {
      throw new util.ValueError('start_num must be greater than or equal to 1');
    }
    if (startingAt > textToSearch.length) {
      throw new util.ValueError('start_num must be less than or equal to the length of text_to_search');
    }

    // Index correction for 1-based index
    const zeroBasedStartingAt = startingAt - 1;

    // Find the index of the searchFor in the textToSearch starting from startingAt
    const sanitizedSearchFor = sanitizeRegex(searchFor);
    const regex = new RegExp(String.raw`${sanitizedSearchFor}`, 'gis');
    const index = textToSearch.slice(zeroBasedStartingAt).search(regex);
    if (index < 0) {
      throw new util.ValueError(`'${searchFor}' not found in '${textToSearch}'`);
    }
    return index + startingAt;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
